// jsdom forbids stubbing window.location, so components call this wrapper
// and tests mock the module instead.
export function reloadPage() {
  window.location.reload();
}

// Leaves the app for a URL the server gave us, so the browser makes a fresh
// request. Same reason as reloadPage: jsdom forbids stubbing window.location.
export function navigateTo(url) {
  window.location.assign(url);
}

// As navigateTo, but replaces this page in the history, so Back skips it.
export function replaceLocation(url) {
  window.location.replace(url);
}
